/* eslint-disable no-use-before-define */
import * as _ from 'lodash';
import simpleBackendRequest from './simpleBackendRequest';
import { PbDispatch, PbGetState } from '../index';
import { MaybeLogoutFromPartnerBoard } from '../authSlice';

interface ErrorWithResponse extends Error {
    response?: any;
    body?: unknown;
}

const ENDPOINTS_WITH_LOGOUT: RegExp[] = [
    /v3\/partners\/users\/\w+/,
    /v1\/users\/me/,
];

function authenticatedBackendRequest<T>(
    extDispatch,
    url: string,
    request: RequestInit
): Promise<T> {
    return new Promise((resolve, reject) => {
        extDispatch((dispatch: PbDispatch, getState: PbGetState) =>
            internalAuthRequest<T>(dispatch, getState, url, request).then(
                resolve,
                reject
            )
        );
    });
}

async function internalAuthRequest<T>(
    dispatch: PbDispatch,
    getState: PbGetState,
    url: string,
    request: RequestInit
): Promise<T> {
    const authToken = getAuthToken(getState);
    const authHeaders = {
        Authorization: `Bearer ${authToken}`,
    };
    const options = _.defaultsDeep({}, request, { headers: authHeaders });
    const response: Response = await simpleBackendRequest(url, options);
    await checkAuth(dispatch, response);
    return (await response.json()) as T;
}

function getAuthToken(getState: PbGetState): string {
    return getState().auth.authentication.token;
}

async function checkAuth(dispatch: PbDispatch, response: Response) {
    if (!response || response.status < 400) {
        return response;
    }

    if (response.status === 401) {
        const shouldLogout = ENDPOINTS_WITH_LOGOUT.some((r) =>
            r.test(response.url)
        );
        if (shouldLogout) {
            dispatch(MaybeLogoutFromPartnerBoard());
        }
    }
    throw await createApiError(response);
}

async function createApiError(response: Response) {
    const error: ErrorWithResponse = new Error(response.statusText);
    error.response = response;
    try {
        const body: { message?: string } = await response.json();
        error.body = body;
        if (body?.message) {
            error.message = body?.message;
        }
    } catch {}
    return error;
}

export default authenticatedBackendRequest;
